const FormField = ({
  label,
  error,
  icon: Icon,
  rightElement,
  children,
}) => (
  <div className="field">
    {label && <label className="field-label">{label}</label>}
    <div className={`field-input-wrap ${error ? 'has-error' : ''}`}>
      {Icon && <Icon size={15} className="field-icon" />}
      {children}
      {rightElement}
    </div>
    {error && <span className="field-error" role="alert">{error}</span>}
  </div>
);

export default FormField;